import { all, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ExternalRestClient } from '~/modules/requests';
import {
  submitGdprConsentRecord,
  submitGdprConsentRecordSuccess,
  submitGdprConsentRecordFailure,
} from '~/actions';
import { CONFIG } from '~/config';
import { ApiResponse } from '~/types';

const GDPR_CONSENT_RECORD_ENDPOINT = `${CONFIG.app.helpCenterLink}/wp-json/tripenger-gdpr-consent/v1/accept`;
const GDPR_CONSENT_VERSION = '1.0';

interface SubmitGdprConsentRecordPayload {
  consentVersion?: string;
}

export function* submitGdprConsentRecordSaga({ payload }: PayloadAction<SubmitGdprConsentRecordPayload | undefined>) {
  try {
    const response: ApiResponse<{ success?: boolean; consent_id?: string }> = yield ExternalRestClient.post(
      GDPR_CONSENT_RECORD_ENDPOINT,
      {
        consent_version: payload?.consentVersion || GDPR_CONSENT_VERSION,
      },
    );

    if (response.status >= 200 && response.status < 300 && response.data?.success) {
      yield put(submitGdprConsentRecordSuccess());
      return;
    }

    yield put(submitGdprConsentRecordFailure({ errorMessage: 'Failed to store GDPR consent record.' }));
  } catch (error: any) {
    yield put(submitGdprConsentRecordFailure({
      errorMessage: error?.response?.data?.message || error.message || 'Failed to store GDPR consent record.',
    }));
  }
}

export default function* root() {
  yield all([
    takeLatest(submitGdprConsentRecord.type, submitGdprConsentRecordSaga),
  ]);
}
